<template>
    <div>
        <hero-bar :has-right-visible="true" menu-icon="desktop-mac">
            {{ $lang.ReportPage.Title_1 }}

            <p class="control" slot="right" style="margin-right: 16px">
                <b-button class="button is-gray" @click="previous">{{ $lang.Menus.BackBtn }}</b-button>
            </p>
            <p class="control" slot="right" v-if="!$store.state.isResultValid">
                <b-button class="button is-primary" @click="openFanCalc">{{ $lang.Menus.FanCalcBtn }}</b-button>
            </p>
        </hero-bar>

        <div class="wizard">
            <div class="wizard-rail">
                <verticalStep-bar />
            </div>
            <div class="wizard-body">
                <pdf-frame :src="pdfsrc" :loading="isLoading" :failed="pdfFailed" />
            </div>
        </div>

        <b-modal v-model="isLoginModalActive" has-modal-card :width="420">
            <div class="modal-card report-login">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $lang.Login.LoginTitle }}</p>
                </header>
                <section class="modal-card-body">
                    <b-field :label="$lang.Login.Email" :type="{ 'is-danger': hasError_email || hasError_signIn }" :message="emptyWarning_email">
                        <b-input type="email" v-model="email" placeholder="ad@firma.com" required></b-input>
                    </b-field>
                    <b-field :label="$lang.Login.Password" :type="{ 'is-danger': hasError_password || hasError_signIn }" :message="emptyWarning_password || warning_signIn">
                        <!-- Enter signs in from the box, not from the show / hide toggle beside it. -->
                        <password-input v-model="password" required @keyup.native.enter="$event.target.tagName === 'INPUT' && signIn()"></password-input>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <b-button :label="$lang.Login.SignUpBtn" @click="openSignUpPage()" />
                    <b-button :label="$lang.Login.LoginBtn" type="is-primary" @click="signIn()" />
                </footer>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';
    import VerticalStepBar from '@/components/VerticalStepBar.vue';
    import PdfFrame from '@/components/PdfFrame.vue';
    import PasswordInput from '@/components/PasswordInput.vue';

    export default {
        name: 'ReportPdfPage',
        components: {
            VerticalStepBar,
            PdfFrame,
            PasswordInput
        },
        data() {
            return {
                isActive: true,
                isLoading: false,
                pdfFailed: false,
                pdfsrc: '',
                isLoginModalActive: false,
                canSignIn: false,
                hasError_email: false,
                emptyWarning_email: '',
                hasError_password: false,
                emptyWarning_password: '',
                hasError_signIn: false,
                warning_signIn: '',
                email: '',
                password: ''
            }
        },
        mounted() {
            this.setCurrentDate();
            this.setProjectInfos();
            this.setPanelInfos();
            this.setEnvConditions();
            this.setCalculationDatas();

            this.saveProject();
            this.$store.state.activeStep = 5;
            this.$store.state.isFooterFixed = true;
        },
        beforeDestroy() {
            this.releasePdf();
        },
        methods: {
            openSignUpPage() {
                this.$store.state.currentRoute = this.$route.name;
                router.push('/addMember');
            },
            signIn() {
                if (this.email == '') {
                    this.hasError_email = true;
                    this.emptyWarning_email = this.$lang.Menus.EmptyWarning;
                } else if (this.password == '') {
                    this.hasError_password = true;
                    this.emptyWarning_password = this.$lang.Menus.EmptyWarning;
                } else {
                    this.canSignIn = true;

                    // The same sign-in as LoginMember (docs/16-api-authorization.md). An empty
                    // answer is refused here too: the old sign-in once took one for a member and
                    // handed the guest's project to member 0.
                    api.members.login(this.email, this.password, false).then((res) => {
                        if (res.isError || !res.data || !res.data.Member || !res.data.Member.Id) {
                            this.hasError_signIn = true;
                            this.warning_signIn = this.$lang.Menus.LoginWarning;
                            return;
                        }
                        this.hasError_signIn = false;
                        this.warning_signIn = '';

                        this.$store.commit('signedIn', { member: res.data.Member, token: res.data.Token, expiresAt: res.data.ExpiresAt, rememberMe: false });

                        api.panels.claimProject(this.$store.state.projectId).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                this.$store.commit('basic', { key: 'guestKey', value: '' });
                                this.updateAcceptLog_2();
                                this.isLoginModalActive = false;
                                this.getReportPdf(this.$store.state.projectId);
                            }
                        });
                    });
                }

                if (this.email != '') {
                    this.hasError_email = false;
                }
                if (this.password != '') {
                    this.hasError_password = false;
                }
            },
            // The report arrives as a Blob; the frame shows it from an object URL, released when
            // it is replaced or the page closes. A guest gets the viewer without its toolbar.
            showPdf(blob) {
                this.releasePdf();
                this.pdfsrc = URL.createObjectURL(blob) + (this.$store.state.memberId == 'TestMember' ? '#toolbar=0' : '');
            },
            releasePdf() {
                if (this.pdfsrc) {
                    URL.revokeObjectURL(this.pdfsrc.split('#')[0]);
                    this.pdfsrc = '';
                }
            },
            getReportPdf(proId) {
                this.isLoading = true;
                this.pdfFailed = false;
                api.panels.getReportPdf(this.$lang.Format.Lang, this.$store.state.memberId, proId).then((res) => {
                    this.isLoading = false;
                    if (res.isError) {
                        this.pdfFailed = true;
                        return;
                    }
                    this.showPdf(res.data);
                });
            },
            saveProject() {
                this.calcIndex = this.$store.state.calcIndex;
                var newSair = this.Sair;
                if (this.Sair == 'N/A') {
                    newSair = null;
                }

                if (!this.$store.state.isPrevProject) {
                    if (this.$store.state.projectId == this.$store.state.prevProjectId) {
                        const project = {
                            ProjectId: this.$store.state.projectId,
                            MemberId: this.$store.state.memberId,
                            IsCompleted: 1,
                            ProjectName: this.projectName,
                            PanelName: this.panelName,
                            PanelNo: this.panelNo,
                            PanelManifacturer: this.panelManifacturer,
                            LastUserName: this.lastUserName,
                            PanelRatedCurrent: this.panelRatedCurrent,
                            RatedCurrentIndex: this.$store.state.ratedCurrentIndex,
                            TotalEyesNumber: this.totalEyesNumber,
                            EyeNo: this.eyesNumber,
                            PanelType: this.panelType,
                            PanelTypeId: this.$store.state.panelTypeIndex,
                            PanelDimension: this.panelDimension,
                            IP: this.panelIP,
                            Sair: newSair,
                            SurfaceInfo: this.$store.state.surfaceExplanation,
                            VirtualSurface: this.$store.state.virtualSurface,
                            VirtualSurfaceIndex: this.$store.state.virtualSurfaceIndex,
                            VirtualSurfaceOption: this.$store.state.virtualSurfaceOption,
                            SeperationNumber: this.seperationNumber,
                            Ae: this.$store.state.ae_value,
                            Ta: this.envTemperature,
                            Tmax: this.maxTemperature,
                            Altitude: this.altitude,
                            CalcTypeId: this.calcIndex,
                            KnownLostPower: this.knownTotalLostpower,
                            InPanelTemp: this.inPanelTemperature,
                            InEnvTemp: this.envMeasureTemperature,
                            InPanelLostPower: this.inPanelTotalLostpower,
                            CalcDeviceLostPower: this.$store.state.totalLostPower_3,
                            ReportDate: this.currentDate2,
                            IsValid: this.$store.state.isResultValid
                        };
                        if (this.$store.state.memberId == 'TestMember') {
                            this.isLoginModalActive = true;
                        }
                        api.panels.updateProject(project).then((res) => {
                            if (res.isError) {
                                console.log("error ");
                            } else {
                                this.$buefy.toast.open(this.$lang.ReportPage.Updated);
                                this.getReportPdf(this.$store.state.projectId);
                            }
                        });
                    } else {
                        const project = {
                            MemberId: this.$store.state.memberId,
                            IsCompleted: 1,
                            ProjectName: this.projectName,
                            PanelName: this.panelName,
                            PanelNo: this.panelNo,
                            PanelManifacturer: this.panelManifacturer,
                            LastUserName: this.lastUserName,
                            PanelRatedCurrent: this.panelRatedCurrent,
                            RatedCurrentIndex: this.$store.state.ratedCurrentIndex,
                            TotalEyesNumber: this.totalEyesNumber,
                            EyeNo: this.eyesNumber,
                            PanelType: this.panelType,
                            PanelTypeId: this.$store.state.panelTypeIndex,
                            PanelDimension: this.panelDimension,
                            IP: this.panelIP,
                            Sair: newSair,
                            SurfaceInfo: this.$store.state.surfaceExplanation,
                            VirtualSurface: this.$store.state.virtualSurface,
                            VirtualSurfaceIndex: this.$store.state.virtualSurfaceIndex,
                            VirtualSurfaceOption: this.$store.state.virtualSurfaceOption,
                            SeperationNumber: this.seperationNumber,
                            Ae: this.$store.state.ae_value,
                            Ta: this.envTemperature,
                            Tmax: this.maxTemperature,
                            Altitude: this.altitude,
                            CalcTypeId: this.calcIndex,
                            KnownLostPower: this.knownTotalLostpower,
                            InPanelTemp: this.inPanelTemperature,
                            InEnvTemp: this.envMeasureTemperature,
                            InPanelLostPower: this.inPanelTotalLostpower,
                            CalcDeviceLostPower: this.$store.state.totalLostPower_3,
                            ReportDate: this.currentDate2,
                            IsValid: this.$store.state.isResultValid
                        };
                        if (this.$store.state.memberId == 'TestMember') {
                            this.isLoginModalActive = true;
                        }

                        api.panels.addNewProject(project).then((res) => {
                            if (res.isError) {
                                this.$buefy.dialog.alert(this.$errorModal(res));
                            } else {
                                // A guest's project opens only with its key: kept before the
                                // calls that follow, which need it.
                                var newProjectId = res.data.ProjectId;
                                if (res.data.GuestKey) {
                                    this.$store.commit('basic', { key: 'guestKey', value: res.data.GuestKey });
                                }
                                this.getReportPdf(newProjectId);

                                var oldProjectId = this.$store.state.projectId;
                                this.updateAcceptLog(oldProjectId, newProjectId);
                                this.updateCalcDevices(oldProjectId, newProjectId);
                                this.$store.state.projectId = newProjectId;

                                this.$store.state.prevProjectId = newProjectId;
                                this.$buefy.toast.open(this.$lang.ReportPage.Saved);
                            }
                        });
                    }
                } else {
                    const project = {
                        ProjectId: this.$store.state.projectId,
                        MemberId: this.$store.state.memberId,
                        IsCompleted: 1,
                        ProjectName: this.projectName,
                        PanelName: this.panelName,
                        PanelNo: this.panelNo,
                        PanelManifacturer: this.panelManifacturer,
                        LastUserName: this.lastUserName,
                        PanelRatedCurrent: this.panelRatedCurrent,
                        RatedCurrentIndex: this.$store.state.ratedCurrentIndex,
                        TotalEyesNumber: this.totalEyesNumber,
                        EyeNo: this.eyesNumber,
                        PanelType: this.panelType,
                        PanelTypeId: this.$store.state.panelTypeIndex,
                        PanelDimension: this.panelDimension,
                        IP: this.panelIP,
                        Sair: newSair,
                        SurfaceInfo: this.$store.state.surfaceExplanation,
                        VirtualSurface: this.$store.state.virtualSurface,
                        VirtualSurfaceIndex: this.$store.state.virtualSurfaceIndex,
                        VirtualSurfaceOption: this.$store.state.virtualSurfaceOption,
                        SeperationNumber: this.seperationNumber,
                        Ae: this.$store.state.ae_value,
                        Ta: this.envTemperature,
                        Tmax: this.maxTemperature,
                        Altitude: this.altitude,
                        CalcTypeId: this.calcIndex,
                        KnownLostPower: this.knownTotalLostpower,
                        InPanelTemp: this.inPanelTemperature,
                        InEnvTemp: this.envMeasureTemperature,
                        InPanelLostPower: this.inPanelTotalLostpower,
                        CalcDeviceLostPower: this.$store.state.totalLostPower_3,
                        ReportDate: this.currentDate2,
                        IsValid: this.$store.state.isResultValid
                    };

                    api.panels.updateProject(project).then((res) => {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            this.$buefy.toast.open(this.$lang.ReportPage.Updated);
                            this.getReportPdf(this.$store.state.projectId);
                        }
                    });
                }
            },
            updateCalcDevices(oldProjectId, newProjectId) {
                api.panels.updateCalcTables_1(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_2(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_3(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_4(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_5(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_6(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
                api.panels.updateCalcTables_7(oldProjectId, newProjectId).then((res) => {
                    if (res.isError) {
                        console.log("error ");
                    }
                });
            },
            setCurrentDate() {
                var currDate = new Date();
                var day = String(currDate.getDate()).padStart(2, '0');
                var month = String(currDate.getMonth() + 1).padStart(2, '0');
                var year = currDate.getFullYear();
                this.currentDate = day + "/" + month + "/" + year;
                this.currentDate2 = year + "-" + month + "-" + day;
            },
            setProjectInfos() {
                this.projectName = this.$store.state.projectName;
                this.panelName = this.$store.state.panelName;
                this.panelNo = this.$store.state.panelNo;
                this.panelRatedCurrent = this.$store.state.panelRatedCurrent;
                if (this.$store.state.ratedCurrentIndex == 3) {
                    this.isMultiEyed = true;
                } else {
                    this.isMultiEyed = false;
                }
                this.totalEyesNumber = this.$store.state.totalEyesNumber;
                this.eyesNumber = this.$store.state.eyesNumber;
                this.lastUserName = this.$store.state.lastUserName;
                this.panelManifacturer = this.$store.state.panelManifacturer;
            },
            setPanelInfos() {
                this.panelType = this.$store.state.panelType;
                this.panelDimension = this.$store.state.panelDimension;
                this.panelIP = this.$store.state.panelIP;
                this.virtualSurface = this.$store.state.surfaceExplanation;
                this.Sair = this.$store.state.Sair;
                this.virtualSurfaceOption = this.$store.state.virtualSurfaceOption;
                this.seperationNumber = this.$store.state.seperationNumber;
                if (this.$store.state.ratedCurrentIndex == 2 || this.$store.state.ratedCurrentIndex == 3) {
                    this.total_Ae = this.$store.state.ae_value;
                    this.aevalues = this.$store.state.ae_valueList;
                } else {
                    this.total_Ae = 'N/A';
                    this.aevalues = ['N/A', 'N/A', 'N/A', 'N/A', 'N/A'];
                }
            },
            setEnvConditions() {
                this.envTemperature = this.$store.state.envTemperature;
                this.maxTemperature = this.$store.state.maxTemperature;
                this.humidity = this.$store.state.humidity;
                this.altitude = this.$store.state.altitude;
            },
            setCalculationDatas() {
                this.knownTotalLostpower = this.$store.state.totalLostPower_1;

                this.inPanelTemperature = this.$store.state.inPanelTemperature;
                this.envMeasureTemperature = this.$store.state.envMeasureTemperature;
                this.inPanelTotalLostpower = this.$store.state.totalLostPower_2;
            },
            updateAcceptLog(oldProjectId, newProjectId) {
                if (this.$store.state.memberId != 'TestMember') {
                    const log = {
                        MemberId: this.$store.state.memberId,
                        ProjectId: newProjectId,
                        OldProjectId: oldProjectId
                    };
                    api.panels.updateAcceptLog(log).then((res) => {
                        if (res.isError) {
                            console.log("error ");
                        } else {

                        }
                    });
                }
            },
            updateAcceptLog_2() {
                if (this.$store.state.memberId != 'TestMember') {
                    const log = {
                        MemberId: this.$store.state.memberId,
                        ProjectId: this.$store.state.projectId,
                        OldProjectId: this.$store.state.projectId
                    };
                    api.panels.updateAcceptLog(log).then((res) => {
                        if (res.isError) {
                            console.log("error ");
                        } else {

                        }
                    });
                }
            },
            openFanCalc() {
                this.$store.isPageOpenedFromStepBar = false;
                router.push('/fan_Calc');
            },
            previous() {
                this.$store.isPageOpenedFromStepBar = false;

                router.push('/results');
            }
        },

    };
</script>